// 9fbef606107a605d69c0edbcd8029e5d
export const KEY_CODES = {
  KEY_TAB: 9,
  KEY_ENTER: 13,
  KEY_SPACE: 32,
  KEY_ESCAPE: 27,
  KEY_UP: 38,
  KEY_DOWN: 40,
  KEY_HOME_KEY: 36,
  KEY_END_KEY: 35,
  KEY_SHIFT: 16,
};

export default {
  KEY_CODES,
};
